module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "roster-user-item",
    attrs: {
      "x12": "",
      "sm12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.deleteFunc) ? _c('v-btn', {
    staticClass: "text-btn error px-2",
    nativeOn: {
      "click": function($event) {
        _vm.deleteFunc(_vm.user)
      }
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]) : _vm._e(), _vm._v(" "), (_vm.status !== '') ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.status !== '') ? _c('v-btn', {
    staticClass: "text-btn black px-2",
    class: {
      error: _vm.status == 'denied'
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e(), _vm._v(" "), (_vm.denyFunc) ? _c('v-btn', {
    staticClass: "text-btn error px-2",
    nativeOn: {
      "click": function($event) {
        _vm.denyFunc(_vm.user)
      }
    }
  }, [_vm._v("Deny")]) : _vm._e(), _vm._v(" "), (_vm.acceptFunc) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.acceptFunc) ? _c('v-btn', {
    staticClass: "text-btn px-2",
    nativeOn: {
      "click": function($event) {
        _vm.acceptFunc(_vm.user)
      }
    }
  }, [_vm._v("Accept")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85fe6d24","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/label/components/user.vue
// module id = 1806
// module chunks = 180